import "./General.css";
import { useEffect, useState } from "react";
export default function General({ tablename, teamcode, title }) {
  const [TeamData, setTeamData] = useState(null);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";
  useEffect(() => {
    if (!teamcode) return;
    // Fetch from FastAPI
    const fetchTeam = async () => {
      try {
        const response = await fetch(
          `${API_URL}/fetch/${tablename}/${teamcode}`,
        );
        const data = await response.json();
        console.log("datatt", data);
        setTeamData(data);
      } catch (err) {
        console.error("Error fetching team:", err)
      }
    };
    fetchTeam();
  }, []);

  // ----------------------- reusable stat pair compnent --------------------
  function renderStatPair(home, away) {
    const getClass = (h, a) => (h > a ? "higher" : h < a ? "lower" : "equal");

    return (
      <>
        <span className={`xg-value xg-home ${getClass(home, away)}`}>
          {home ?? "N/A"}
        </span>
        <span className="xg-separator">–</span>
        <span className={`xg-value xg-away ${getClass(away, home)}`}>
          {away ?? "N/A"}
        </span>
      </>
    );
  }

  // -------------------------- goals comparison ----------------------
  function renderStatPair_goal(homeScore, awayScore) {
    const parseScore = (score) => {
      if (!score) return 0;
      const parts = score.split(":").map(Number);
      return parts.reduce((a, b) => a + b, 0); // sum of goals
    };

    const homeTotal = parseScore(homeScore);
    const awayTotal = parseScore(awayScore);

    const getClass = (h, a) => (h > a ? "higher" : h < a ? "lower" : "equal");

    return (
      <>
        <span className={`xg-value xg-home ${getClass(homeTotal, awayTotal)}`}>
          {homeScore ?? "N/A"}
        </span>
        <span className="xg-separator">–</span>
        <span className={`xg-value xg-away ${getClass(awayTotal, homeTotal)}`}>
          {awayScore ?? "N/A"}
        </span>
      </>
    );
  }

  return (
    <>
      {TeamData ? (
        <div className="general-calc">
          <h2 className="general-calc-title">{title}</h2>
          <div className="general-calc-content">
            {/* ---- expected Goals ------ */}
            <span>
              <div className="xg-card">
                <h6 className="xg-title">Expected Goals</h6>
                <div className="xg-values">
                  {renderStatPair(TeamData?.H_exp_g, TeamData?.A_exp_g)}
                </div>
              </div>
            </span>

            {/* --------- home, draw, away ------------ */}
            <span>
              <div className="xg-card">
                <h6 className="xg-title">1X2 - Percentage</h6>
                <div className="xg-values">
                  <span className="xg-value xg-home">
                    {TeamData?.H_win ?? "N/A"}
                  </span>
                  <span className="xg-separator">–</span>
                  <span className="xg-value xg-away">
                    {TeamData?.Draw ?? "N/A"}
                  </span>
                  <span className="xg-separator">–</span>
                  <span className="xg-value xg-away">
                    {TeamData?.A_win ?? "N/A"}
                  </span>
                </div>
              </div>
            </span>

            {/* ---------CS 1 ------------ */}
            <span>
              <div className="xg-card">
                <h6 className="xg-title"> CS_1 :: CS_2</h6>
                <div className="xg-values">
                  {renderStatPair_goal(TeamData?.CS1, TeamData?.CS2)}
                </div>
              </div>
            </span>

            {/* --------- UND_25 || OVER_25 ------------ */}
            <span>
              <div className="xg-card">
                <h6 className="xg-title"> UND_25 :: OVR_25</h6>
                <div className="xg-values">
                  {renderStatPair(TeamData?.Und_25, TeamData?.Ovr_25)}
                </div>
              </div>
            </span>
            {/* --------- UND_35 || OVER_35 ------------ */}
            <span>
              <div className="xg-card">
                <h6 className="xg-title"> UND_35 :: OVR_35</h6>
                <div className="xg-values">
                  {renderStatPair(TeamData?.Und_35, TeamData?.Ovr_35)}
                </div>
              </div>
            </span>
            {/* --------- GG || N_GG ------------ */}
            <span>
              <div className="xg-card">
                <h6 className="xg-title"> GG :: N_GG</h6>
                <div className="xg-values">
                  {renderStatPair(TeamData?.GG, TeamData?.N_GG)}
                </div>
              </div>
            </span>
          </div>
        </div>
      ) : (
        <p>no data found</p>
      )}
    </>
  );
}
